import React from 'react';

import { useGetEvents } from '@vlabs/api/artemy/client';
import type { StreamId } from '@vlabs/api/artemy/model';

import { useSourceLivePageTranslation } from '../i18n';
import { LiveEventCard } from './LiveEventCard';
import st from './LiveEventsPanel.module.sass';

const PAGE_SIZE = 30;

interface LiveEventsPanelProps {
  streamId: StreamId;
}

// Лента последних событий потока: 30 последних по дате (REST; WS в artemy не поддержан).
function LiveEventsPanel({ streamId }: LiveEventsPanelProps): React.JSX.Element {
  const { t } = useSourceLivePageTranslation();

  const { data } = useGetEvents({
    stream_ids: [streamId],
    page_size: PAGE_SIZE,
    order: 'desc',
  });

  const events = data?.events ?? [];

  let body: React.JSX.Element;
  if (events.length > 0) {
    body = (
      <div className={st.List}>
        {events.map((event) => (
          <LiveEventCard
            event={event}
            key={event.event_id}
          />
        ))}
      </div>
    );
  } else {
    // Пустая лента — сообщение сверху панели, без растянутого списка
    body = (
      <div className={st.Empty}>
        {t('no_events')}
      </div>
    );
  }

  return (
    <div className={st.Root}>
      {body}
    </div>
  );
}

export { LiveEventsPanel };
